document.addEventListener('click', async (e) => {
    const cdr_add_to_cart_btn = e.target.closest('.cdr-add-to-cart-btn');
    if (!cdr_add_to_cart_btn) {
        return;
    }

    const variantId = cdr_add_to_cart_btn.dataset.variantId;
    const quantity = 1;
    const spinner = cdr_add_to_cart_btn.querySelector('.loading__spinner');
    spinner?.classList.remove('hidden');

    try {
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
                items: [{ id: variantId, quantity }],
                sections: ['cart-drawer', 'cart-icon-bubble'],
                sections_url: window.location.pathname
            })
        });

        if (!response.ok) throw new Error('Cart add failed');

        const cartData = await response.json();
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
            cartDrawer.classList.remove('is-empty');
            cartDrawer.renderContents(cartData);
            cartDrawer.open();
        }
    } catch (err) {
        console.error(err);
    } finally {
        spinner?.classList.add('hidden');
    }
});
